<template>
  <div class="flammable-gas-container">
    <div class="article-title">可燃气体：</div>
    <div class="article-content">
      又称易燃气体，是指能与空气（或氧气）在一定的浓度范围内均匀混合，形成预混气，遇到点火源（如明火、电火花、高温表面）会发生燃烧或爆炸的气体。
    </div>
    <div class="article-title">爆炸极限：</div>
    <div class="article-content">
      这是衡量其危险性的最关键指标。它指可燃气体在空气中能发生爆炸的最低浓度（爆炸下限，LEL）和最高浓度（爆炸上限，UEL）。浓度低于下限或高于上限，混合物都不会爆炸。例如，最常见的家用天然气（主要成分甲烷）的爆炸极限约为5%
      - 15%。
    </div>

    <div class="article-title">常见可燃气体：</div>
    <div class="article-content">
      家庭与民用：天然气（甲烷）、液化石油气（丙烷、丁烷）。
      工业与能源：氢气（清洁能源载体）、一氧化碳（煤气主要成分）、乙炔（用于金属焊接切割）。
    </div>

    <div class="article-title">主要危险与安全须知：</div>
    <div class="article-content">
      可燃气体最大的风险是引发火灾和爆炸，其危险性远大于单纯的有毒气体（如VOC的毒性危害）。因此，安全使用至关重要：

      <ul>
        <li>1、密闭与通风：使用和存储区域必须保证良好通风，防止气体聚集达到爆炸极限。</li>
        <li>
          2、泄漏检测：必须安装可燃气体报警器（监测LEL百分比），一旦泄漏浓度达到安全阈值（通常设定为爆炸下限的10%-25%），会立即报警。
        </li>
        <li>3、杜绝火源：在可能存在泄漏的区域，严禁任何形式的明火、火花和高温。</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style lang="scss">
.flammable-gas-container {
  @include scrollar-style-bold;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  .article-title {
    font-size: 20px;
    font-weight: bold;
    margin: 20px 0;
  }
  .sub-title {
    font-size: 18px;
    font-weight: bold;
    text-indent: 10px;
    margin-left: 20px;
  }
  .article-content {
    font-size: 16px;
    text-indent: 10px;

    ul {
      margin-top: 10px;
      text-indent: 45px;
      line-height: 1.6;
    }
  }
}
</style>
